import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20beautiful%20Mimosa%20pudica%20sensitive%20plant%20with%20delicate%20feathery%20green%20leaves%20in%20full%20bloom%20with%20soft%20pink%20pom-pom%20flowers%20placed%20on%20a%20minimal%20wooden%20surface%20against%20a%20soft%20cream%20background%20natural%20morning%20light%20creating%20gentle%20shadows%20elegant%20botanical%20photography%20style%20warm%20and%20inviting%20atmosphere%20clean%20composition%20with%20ample%20negative%20space&width=1800&height=900&seq=hero-mimosa-main&orientation=landscape"
          alt="害羞草 - 触碰即合的神奇植物"
          title="害羞草 - 含羞草完全指南"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/15 to-black/35"></div>
      </div>
      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center px-4 text-center">
        <span className="inline-block bg-primary-500/90 text-background-50 text-xs md:text-sm font-medium px-4 py-1.5 rounded-full mb-4 md:mb-6">
          触碰即合的神奇植物
        </span>
        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-3 md:mb-4 max-w-3xl leading-tight">
          害羞草完全指南
        </h1>
        <p className="text-base md:text-lg text-white/80 max-w-2xl mb-6 md:mb-8 leading-relaxed">
          从生长习性到科学原理，从种植技巧到养护心得
          <br className="hidden sm:block" />
          最全面的中文含羞草知识平台
        </p>
        <div className="flex flex-col sm:flex-row items-center gap-3">
          <Link
            to="/category/zhongzhi-fangfa"
            className="bg-primary-500 hover:bg-primary-600 text-background-50 px-6 py-3 rounded-md font-medium text-sm md:text-base transition-colors cursor-pointer whitespace-nowrap"
          >
            开始种植之旅
          </Link>
          <Link
            to="/category/kexue-yuanli"
            className="bg-white/20 hover:bg-white/30 text-white border border-white/30 px-6 py-3 rounded-md font-medium text-sm md:text-base transition-colors cursor-pointer whitespace-nowrap backdrop-blur-sm"
          >
            探索科学原理
          </Link>
        </div>
      </div>
    </section>
  );
}